type EventProps = Readonly<Record<string, string>>;

export const extractEventPropsFromElement = (element: Element): EventProps => {
  return Array.from(element.attributes)
    .filter((attr) => attr.name.startsWith("data-event-prop-"))
    .reduce<Record<string, string>>((acc, attr) => {
      const name = attr.name.replace("data-event-prop-", "");
      acc[name] = attr.value;
      return acc;
    }, {});
};
